import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { DeliveryOrder } from "../state/types"

export const useDeliveryOrderActions = () => {
    const saveActions = useSaveActions()

    const saveDeliveryOrder = (deliveryOrder: DeliveryOrder) => {
        const { save } = saveActions()
        return save(TableName.DELIVERY_ORDERS, deliveryOrder) as Promise<DeliveryOrder>
    }

    const removeDeliveryOrder = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.DELIVERY_ORDERS, id)
    }

    return {
        saveDeliveryOrder,
        removeDeliveryOrder
    }
}
